const React = require('react');
const Layout = require('./src/components/view/layout/Layout').default;
const { RouteAnimateProvider } = require('./src/context/RouteAnimationContext');

exports.wrapPageElement = ({ element, props }) => {
  return element;
};
